import axios from "axios";
import type { Application } from "@/types/jben/application.ts";

type Args = {
  application: Application;
  submitPath: string;
  fingerprint: string;
  jobApplicationRequestToken?: string;
};

export async function submitApplication({
  application,
  submitPath,
  fingerprint,
  jobApplicationRequestToken,
}: Args) {
  const body: Record<string, unknown> = {
    job_application: application,
    fingerprint,
  };

  if (jobApplicationRequestToken) {
    body["request_token"] = jobApplicationRequestToken;
  }

  return axios.post(submitPath, body);
}
